<template>
  <div
    class="container-range"
  >
    <SbRadioButton
      v-model:model="mode"
      value="exactly"
      name="mode"
      :version="dsComponentDetails.version"
    >
      <sb-text :value="labels.exactly" />
    </SbRadioButton>
    <SbRadioButton
      v-model:model="mode"
      value="lessThan"
      name="mode"
      :version="dsComponentDetails.version"
    >
      <sb-text :value="labels.lessThan" />
    </SbRadioButton>
    <SbRadioButton
      v-model:model="mode"
      value="greaterThan"
      name="mode"
      :version="dsComponentDetails.version"
    >
      <sb-text :value="labels.greaterThan" />
    </SbRadioButton>
    <SbRadioButton
      v-model:model="mode"
      value="range"
      name="mode"
      :version="dsComponentDetails.version"
    >
      <sb-text :value="labels.range" />
    </SbRadioButton>

    <component
      :is="type"
      v-if="mode !== 'range'"
      ref="input"
      v-bind="componentAttrs"
      nullable
      :date="currentValue"
      :disabled="!mode"
      :value="currentValue"
      :version="dsComponentDetails.version"
      @change="changeValue"
      @update:model-value="changeValue"
    />
    <div
      v-if="mode === 'range'"
      class="range"
    >
      <component
        :is="type"
        v-bind="componentAttrs"
        nullable
        :disabled="!mode"
        :date="currentValue"
        :value="currentValue"
        :version="dsComponentDetails.version"
        @change="changeRange($event, 'currentValue')"
        @update:model-value="changeRange($event, 'currentValue')"
      />
      <component
        :is="type"
        v-bind="componentAttrs"
        nullable
        :date="currentToValue"
        :disabled="!mode"
        :value="currentToValue"
        :version="dsComponentDetails.version"
        @change="changeRange($event, 'currentToValue')"
        @update:model-value="changeRange($event, 'currentToValue')"
      />
    </div>
  </div>
</template>

<script>
import SbDatePicker from '@src/components/DatePicker/SbDatePicker.vue';
import SbRadioButton from '@src/components/RadioButton/SbRadioButton.vue';
import SbNumberInput from '@src/components/Input/SbNumberInput.vue';
import SbText from '@src/components/Text/SbText.vue';
import { versionedComponentsMixin } from '@src/mixins/versionedComponents';

const DEFAULT_LABELS = {
  exactly: 'range.exactly',
  lessThan: 'range.lessThan',
  greaterThan: 'range.greaterThan',
  range: 'range.range',
};

export default {
  name: 'FilterRange',
  components: {
    SbRadioButton,
    SbText,
    SbNumberInput,
    SbDatePicker,
  },
  mixins: [versionedComponentsMixin],
  props: {
    filter: {
      type: Object,
      required: true,
    },
    filterValue: {
      type: Object,
      default: () => { },
    },
  },
  emits: [
    'update:filter-value',
  ],
  data() {
    return {
      mode: 'exactly',
      currentValue: null,
      currentToValue: null,
    };
  },
  computed: {
    componentAttrs() {
      const { type: _, ...rest } = this.filter.props || {};
      return {
        ...rest,
        class: ['range-input', rest.class].filter(Boolean),
        placeholder: rest.placeholder || 'Enter value',
        step: rest.step || 1,
      };
    },
    type() {
      return this.filter.props?.type;
    },
    labels() {
      return this.filter.props?.labels || DEFAULT_LABELS;
    },
  },
  watch: {
    'filterValue.value': function (newValue) {
      this.mode = newValue?.type;
      this.currentValue = newValue?.fromValue || newValue?.value || null;
      this.currentToValue = newValue?.toValue || null;
    },
    mode(newValue) {
      if (newValue === this.filterValue?.value?.type) return;
      this.mode = newValue;
      this.currentToValue = null;
      if (!this.currentValue) {
        this.$emit('update:filter-value', {
          value: null,
        });
        return;
      }
      if (newValue !== 'range') {
        this.$emit('update:filter-value', {
          value: {
            type: newValue,
            name: this.labels[newValue],
            value: this.currentValue,
          },
        });
      } else {
        this.$emit('update:filter-value', {
          value: {
            type: newValue,
            name: this.labels[newValue],
            fromValue: this.currentValue,
            toValue: this.currentToValue,
          },
        });
      }
    },
  },
  mounted() {
    const newValue = this.filterValue?.value;
    this.currentValue = newValue?.fromValue || newValue?.value || null;
    this.currentToValue = newValue?.toValue || null;
    this.mode = newValue?.type || 'exactly';
  },
  methods: {
    changeValue(event) {
      this.currentValue = event?.target?.value || event?.value || event;
      if (!this.currentValue) {
        return this.$emit('update:filter-value', {
          value: null,
        });
      }
      return this.$emit('update:filter-value', {
        value: {
          value: this.currentValue,
          type: this.mode,
          name: this.labels[this.mode],
        },
      });
    },
    changeRange(event, prop) {
      this[prop] = event?.target?.value || event?.value || event;
      if (!this.currentValue && !this.currentToValue) {
        return this.$emit('update:filter-value', {
          value: null,
        });
      }
      return this.$emit('update:filter-value', {
        value: {
          type: this.mode,
          name: this.labels[this.mode],
          fromValue: this.currentValue,
          toValue: this.currentToValue,
        },
      });
    },
  },
};
</script>

  <style lang="scss" scoped>
  @import '@src/components/Filter/style/sb-range.scss';
  </style>
